import React from "react";

import { tailwind, invertedTailwind, Theme } from "../../../../models/models";
// import { Theme } from "../../../../definitions/models/Theme/Theme";
import { StorageContext } from "../../../storage/storage-context";

interface CssInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  init?: string, //{ [key: string]: string},
  classObject?: { [key: string]: { [key: string]: string } },
}

type JSONObject = { [key: string]: any };
type InvertedObject = { [leafValue: string]: string[] };

function invertJson(obj: JSONObject): InvertedObject {
    const inverted: InvertedObject = {};

    function recurse(current: any, path: string[] = []): void {
        if (current !== null && typeof current === 'object' && !Array.isArray(current)) {
            for (const key in current) {
                if (current.hasOwnProperty(key)) {
                    recurse(current[key], [...path, key]);
                }
            }
        } else {
            // Leaf node reached
            inverted[String(current)] = path;
        }
    }

    recurse(obj);
    return inverted;
}

const generateContiguousSubstringsSorted = (text: string): string[] =>{
    const words = text.trim().split(/\s+/);
    const substrings: string[] = [];

    // Start with the longest possible substring length and go down to 1
    for (let length = words.length; length >= 1; length--) {
        for (let start = 0; start <= words.length - length; start++) {
            const substring = words.slice(start, start + length).join(' ');
            substrings.push(substring);
        }
    }
    return substrings;
}

const cssClassKeyValuesFromString = (classListString: string, classObject = tailwind, invertedClassObject = invertedTailwind) => {
  const substrings: string[] = generateContiguousSubstringsSorted(classListString);
  let remainingString = classListString;
  const result: { [key: string]: string } = {};

  for (const substring of substrings) {
    // console.log('remaining', remainingString);
    if (remainingString.includes(substring)) {
      if (invertedClassObject[substring]) {
        result[invertedClassObject[substring][0]] = (classObject[invertedClassObject[substring][0] as keyof typeof classObject] as any)[invertedClassObject[substring][1]];
        remainingString = remainingString.replace(substring, '').trim();
      }
    }
  }
  return result;
}

const CssInput: React.FC<CssInputProps> = ({ init, classObject = tailwind, value, name, placeholder, onChange, className, ...rest}) => {

  const [storageContext, setStorageContext] = React.useContext(StorageContext);
  
  const inputRef = React.useRef<HTMLInputElement>(null);

  const [cssString, setCssString] = React.useState<string>(init || '');

  const [classKeyValues, setClassKeyValues] = React.useState<{ [key: string]: string }>(cssClassKeyValuesFromString(init || ''));

  const invertedClassObject = React.useMemo(() => invertJson(classObject), [classObject]);

  // React.useEffect(() => {
  //   // console.log('invertedTailwind', invertedTailwind);
  //   // console.log('tailwindkeyvalues', tailwindKeyValues);
  // }, [tailwindKeyValues]);

  React.useEffect(() => {
    if (onChange && inputRef.current) {
      const event = {
        target: {
          value: cssString
        }
      } as React.ChangeEvent<HTMLInputElement>;
      onChange(event);
    }
  }, [cssString]);

  React.useEffect(() => {
    setCssString(Object.keys(classKeyValues).reduce((accumulator, cv) => `${accumulator}${classKeyValues[cv]} `, ''));
  }, [classKeyValues]);

  return (
    <div className="w-full">
      <div className={`${cssString}`}>{ cssString }</div>
      <div className={`grid grid-cols-[minmax(min-content,200px)_1fr] gap-x-4 gap-y-2 items-center w-full`}>  {/*className="flex flex-wrap items-center justify-center"> */}

        {
          Object.keys(classObject).map((k,i) => (
            <React.Fragment key={i}>
              <label className="mx-1">{ k.replaceAll("_", " ") }:</label>
              <select 
                className={`${ (storageContext.theme as Theme).forms.primary } w-auto m-1`} 
                key={i} 
                onChange={(e) => {
                  setClassKeyValues(twkv => ({ ...twkv, [k]: e.target.value }))
                }}
                value={classKeyValues[k]}
              >
                {
                  Object.keys(classObject[k as keyof typeof classObject]).map((o, ii) => (
                    <option key={ii} value={(classObject[k as keyof typeof classObject] as any)[o]}>
                      {o}
                    </option>
                  ))
                }
              </select>
            </React.Fragment>

          ))
        }
      </div>

      <input ref={inputRef} style={{ display: "none" }} className={'hidden'} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setCssString(e.target.value)}} {...rest}/>
    </div>
  )
}

export default CssInput;